import { BaseModel } from "sjs-base-model";

export default class ValoriModelExtended extends BaseModel {
    public readonly percentage: number = 0;
    public readonly amount: number = 0;
    public readonly minValue: number = 0;
    public readonly maxValue: number = 0;

    constructor(data: Partial<ValoriModelExtended>) {
        super();

        this.update(data);
    }
}
